/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Amendment_Queue_TitleInputs */

const en_orders_amendment_queue_title = /** @type {(inputs: Orders_Amendment_Queue_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Amendment Pending Queue`)
};

const es_orders_amendment_queue_title = /** @type {(inputs: Orders_Amendment_Queue_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cola de enmiendas pendientes`)
};

/**
* | output |
* | --- |
* | "Amendment Pending Queue" |
*
* @param {Orders_Amendment_Queue_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_amendment_queue_title = /** @type {((inputs?: Orders_Amendment_Queue_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Amendment_Queue_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_amendment_queue_title(inputs)
	return es_orders_amendment_queue_title(inputs)
});